import { flip, offset, shift, useFloating } from '@floating-ui/react-dom';
import { useMap } from '@vis.gl/react-google-maps';
import { useEffect } from 'react';

/**
 * @param {object} props
 * @param {string} [props.className]
 * @param {React.CSSProperties} [props.style]
 * @param {React.ReactNode} props.children
 * @param {Element} props.anchor
 * @param {string} [props.ariaLabel]
 * @returns {React.JSX.Element}
 */
export function Popup({ className, style, children, anchor, ariaLabel }) {
  const map = useMap();
  const boundary = map?.getDiv();
  const { refs, floatingStyles } = useFloating({
    open: true,
    placement: 'top',
    middleware: [
      offset(4),
      flip({ boundary }),
      shift({
        boundary,
        crossAxis: true,
        padding: 4,
      }),
    ],
  });

  useEffect(() => {
    refs.setReference(anchor);
  }, [refs, anchor]);

  return (
    <div
      ref={refs.setFloating}
      role="dialog"
      tabIndex={-1}
      style={{ ...style, ...floatingStyles }}
      className={className}
      aria-label={ariaLabel}
    >
      {children}
    </div>
  );
}
